import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "../../components/app-toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { APP_PATH } from "../../api/backendPath";
import { ACTIONS_GET_STATISTICS } from "../../action-types/actions";

export const getClaimsStatistics = createAsyncThunk(
  ACTIONS_GET_STATISTICS.getStatistics,
  async (_, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      const response = await axiosPrivate.get(
        `${process.env.REACT_APP_API_URL}${APP_PATH.statistics}`,
      );

      if (response?.data?.status === true || response?.status === 200) {
        return response.data;
      } else {
        toast.error(
          response?.data?.message || "Failed to fetch claims statistics",
        );
        return rejectWithValue(response.data);
      }
    } catch (error) {
      console.error("Error fetching claims statistics:", error);
      const errMsg =
        error?.response?.data?.message ||
        "Something went wrong while fetching claims statistics";
      toast.error(errMsg);
      return rejectWithValue(errMsg);
    }
  },
);
